import { render, staticRenderFns } from "./AppHubTenant.vue?vue&type=template&id=174cd993&scoped=true&"
import script from "./AppHubTenant.vue?vue&type=script&lang=js&"
export * from "./AppHubTenant.vue?vue&type=script&lang=js&"
import style0 from "./AppHubTenant.vue?vue&type=style&index=0&id=174cd993&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174cd993",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})
